import {
  PlanejamentoSituacaoAprovacao,
  PLANEJAMENTO_SITUACAO_LABELS,
  PlanejamentoAulaHorario
} from '../models/planejamento-aula.types';

export const SITUACAO_BADGE_CLASS: Record<PlanejamentoSituacaoAprovacao, string> = {
  APROVADO:             'bg-emerald-600',
  AGUARDANDO_APROVACAO: 'bg-amber-500',
  EM_ANALISE:           'bg-blue-500',
  AGUARDANDO_CORRECAO:  'bg-red-500',
  EM_ELABORACAO:        'bg-[#C4622D]'
};

export function getSituacaoLabel(
  situacao: PlanejamentoSituacaoAprovacao | null | undefined
): string {
  return situacao ? PLANEJAMENTO_SITUACAO_LABELS[situacao] ?? situacao : '';
}

export function getSituacaoBadgeClass(
  situacao: PlanejamentoSituacaoAprovacao | null | undefined
): string {
  return (situacao && SITUACAO_BADGE_CLASS[situacao]) ?? SITUACAO_BADGE_CLASS['EM_ELABORACAO'];
}

/** Formata label da aula no padrão "HH:mm:ss - HH:mm:ss - Nª aula". */
export function formatarLabelAula(aula: PlanejamentoAulaHorario | null | undefined): string {
  if (!aula) { return ''; }
  const inicio  = aula.inicioAula  || aula.horaInicio || '';
  const fim     = aula.fimAula     || aula.horaFim    || '';
  const numero  = aula.numeroAula  ?? aula.numero;
  const horario = fim ? `${inicio} - ${fim}` : inicio;
  const sufixo  = numero != null ? ` - ${numero}ª aula` : '';
  return `${horario}${sufixo}`;
}
